import { STATUS } from "@/utils/constant";
import { generateParams } from "@/utils/helper/generateParams";
import { Link } from "react-router-dom";
import styles from "./RFSStatistics.module.css";

export default function DataCard({
  label,
  value,
  status = "",
  className = "",
}: {
  label: string;
  value?: { total: number; totalHpRfs: number };
  status?: string;
  className?: string;
}) {
  let statusLink;
  if (status === STATUS.RFS.TOTAL_BUCKET_TENANT) {
    statusLink = `/rfs/rfs?statusRfsSubmissionLmsValues=On%20Review%20by%20Tenant,Approved%20by%20Tenant`;
  } else if (status === STATUS.RFS.TOTAL_BUCKET_LINKNET) {
    const statusRfsSubmissionLmsValues = [
      STATUS.RFS_SUBMISSIONS_VALUES.SUBMIT_TO_TENANT,
      STATUS.RFS_SUBMISSIONS_VALUES.REJECTED_BY_TENANT_TO_LINKNET,
      STATUS.RFS_SUBMISSIONS_VALUES.PROCESSING_HPM,
    ].join(",");
    const statusRfsSubmissions = [STATUS.RFS_SUBMISSIONS.REVIEW_BY_LN].join(
      ",",
    );

    const params = generateParams({
      statusRfsSubmissionLmsValues,
      statusRfsSubmissions,
    });

    statusLink = `/rfs/rfs${params}`;
  } else if (status === STATUS.RFS.TOTAL_BUCKET_VENDOR) {
    statusLink = `/rfs/rfs?statusRfsSubmissions=REVISION_DATA,PREPARATION_DATA,REJECTED_DOCUMENT_RFS&statusRfsSubmissionLmsValues=Reject%20by%20Tenant%20to%20Vendor`;
  } else if (Object.values(STATUS.RFS_SUBMISSIONS_VALUES).includes(status)) {
    statusLink = `/rfs/rfs?statusRfsSubmissionLmsValues=${status}`;
  } else if (Object.values(STATUS.RFS_SUBMISSIONS).includes(status)) {
    statusLink = `/rfs/rfs?statusRfsSubmissions=${status}`;
  } else {
    statusLink = `/rfs/rfs?status=${status}`;
  }

  return (
    <li
      className={`${styles.dataCard} w-full max-w-[100] flex-grow rounded text-center text-neutral-800 shadow dark:text-neutral-50 dark:shadow-neutral-700`}
    >
      <Link
        to={statusLink}
        className="flex h-full w-full flex-col items-start justify-center gap-y-2 p-4"
      >
        <span className={`${className}`}>{label}</span>
        <div className="w-full">
          <div className="flex gap-x-2">
            <span className={`${className} block text-2xl`}>
              {value?.total ?? 0}
            </span>
            <span className={`${className} block text-2xl text-black/40`}>
              Docs
            </span>
          </div>
          <div className="flex  gap-x-2">
            <span className={`${className} block text-2xl`}>
              {value?.totalHpRfs ?? 0}
            </span>
            <span className={`${className} block text-2xl text-black/40`}>
              HP
            </span>
          </div>
        </div>
      </Link>
    </li>
  );
}
